/**
 * Inventory Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const inventoryRoutes: RouteRecordRaw[] = [
  {
    path: '/customer-inventory',
    name: 'customer-inventory',
    component: () => import('./views/CustomerInventoryView.vue'),
    meta: {
      title: () => i18next.t('nav.inventory'),
      requiredEntitlement: 'INVENTORY',
      breadcrumbs: [
        { label: () => i18next.t('nav.inventory') },
      ],
    },
  },
  {
    path: '/customer-inventory/:id',
    name: 'inventory-product-detail',
    component: () => import('./views/CustomerInventoryView.vue'),
    meta: {
      title: () => i18next.t('inventory.productDetail'),
      requiredEntitlement: 'INVENTORY',
      breadcrumbs: [
        { label: () => i18next.t('nav.inventory'), to: '/customer-inventory' },
        { label: () => i18next.t('inventory.productDetail') },
      ],
    },
  },
  {
    path: '/customer-inventory/:id/update-stock',
    name: 'inventory-update-stock',
    component: () => import('./views/UpdateStockPage.vue'),
    meta: {
      title: () => i18next.t('inventory.updateStock'),
      requiredEntitlement: 'INVENTORY',
      breadcrumbs: [
        { label: () => i18next.t('nav.inventory'), to: '/customer-inventory' },
        { label: () => i18next.t('inventory.updateStock') },
      ],
    },
  },
];
